module.exports = __webpack_public_path__ + "img/test_j.41cb4a4f.png";